import {
  Button,
  Tabs,
  Popconfirm,
  message,
  Modal,
  Form,
  Input,
  Spin,
  Tag,
} from "antd";
import MenuBar from "./menu/MenuBar";
import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { delUser, setUser } from "../app/features/user/userSlice";
import { postData } from "../data/allfunction";
import { useHistory } from "react-router-dom";

const ip = process.env.REACT_APP_IP;
const { TabPane } = Tabs;

function User() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { token, retoken, user } = useSelector((state) => {
    return state.user;
  });
  const [showuser, setshowuser] = useState([]);

  function getAllUser() {
    const link = `${ip}sell_online/users`;
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    return fetch(link, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => console.log("error", error));
  }

  const setdataShowUser = useCallback(async () => {
    const us = await getAllUser();
    if (us.status === 200) {
      setshowuser(us.data);
    } else {
    }
  }, []);

  useEffect(() => {
    setdataShowUser();
  }, [setdataShowUser]);

  return (
    <>
      <MenuBar />
      <div className="container text-center mt-3">
        <h4>ການຈັດການກ່ຽວກັບຜູ້ໃຊ້ງານ</h4>
      </div>
      <div className="container">
        <Tabs defaultActiveKey="1">
          <TabPane tab="ຜູ້ໃຊ້ງານທັງໝົ້ດ" key="1">
            <Alluser
              data={showuser}
              setdataShowUser={setdataShowUser}
              history={history}
            />
          </TabPane>
          <TabPane tab="ເພີ່ມຜູ້ໃຊ້ງານ" key="2">
            <Adduser setdataShowUser={setdataShowUser} />
          </TabPane>
        </Tabs>
      </div>
    </>
  );

  function Alluser(props) {
    const { data, setdataShowUser, history } = props;
    const [loading, setloading] = useState(false);
    const [visible, setvisible] = useState(false);
    const [loadingDelete, setloadingDelete] = useState(false);
    const [edit_id, setedit_id] = useState("");
    const [edit_pass, setedit_pass] = useState("");
    const [edit_name, setedit_name] = useState("");
    const [edit_level, setedit_leve] = useState("");

    async function confirm(val) {
      //ອັບເດດສະຖານະການໃຊ້ງານ
      let link = `${ip}users/editStatus`;
      let { status, id, name } = val;
      status = parseInt(status);
      let st;
      if (status === 1) {
        st = 0;
      } else {
        st = 1;
      }
      let dataSetForGet = {
        id: id,
        status: st,
      };
      function setWhenUpdate(getWihtToken) {
        if (getWihtToken.data.changedRows === 1) {
          setloadingDelete(true);
          setTimeout(() => {
            setloadingDelete(false);
            if (st === 1) {
              message.info(`ເປີດຜູ້ໃຊ້ງານ ${name} ສຳເຫຼັ້ດ.`);
            } else {
              message.warning(`ຍົກເລີກຜູ້ໃຊ້ງານ ${name} ສຳເຫຼັ້ດ.`);
            }

            setdataShowUser();
          }, 1000);
        } else {
          setloadingDelete(false);
        }
      }
      postData(
        message,
        link,
        dataSetForGet,
        token,
        retoken,
        user,
        dispatch,
        delUser,
        setUser,
        history,
        setWhenUpdate
      );
    }

    const showModal = (val) => {
      setvisible(true);
    };
    const handleOk = async () => {
      //ແກ້ໄຂຍູເຊີ
      if (edit_pass === "") {
        message.info(`ກະລຸນາອັບເດດລະຫັດຜ່ານໃໝ່.`);
      } else {
        let dataSetForGet = {
          id: edit_id,
          level: edit_level,
          pass: edit_pass,
          name: edit_name,
        };
        let link = `${ip}users/editUser`;
        setloading(true);
        postData(
          message,
          link,
          dataSetForGet,
          token,
          retoken,
          user,
          dispatch,
          delUser,
          setUser,
          history,
          setWhenUpdate
        );
      }

      function setWhenUpdate(result) {
        if (result.data.changedRows === 1) {
          setTimeout(() => {
            setloading(false);
            setvisible(false);
            message.info(`ອັບເດດຂໍ້ມູນຜູ້ໃຊ້ງານສຳເຫຼັດ.`);
            setedit_id("");
            setedit_name("");
            setedit_pass("");
            setedit_leve("");
            setdataShowUser();
          }, 1000);
        } else {
          setloading(false);
          setvisible(false);
        }
      }
    };

    const handleCancel = () => {
      setvisible(false);
    };

    function modalEdit() {
      return (
        <Modal
          visible={visible}
          title={"ແກ້ໄຂຜູ້ໃຊ້ງານ " + edit_id}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              ຍົກເລີກ
            </Button>,
            <Button type="primary" loading={loading} onClick={handleOk}>
              ບັນທຶກການແກ້ໄຂ
            </Button>,
          ]}
        >
          <Form>
            <Form.Item label="ລະຫັດຜ່ານ">
              <input
                className="form-control"
                type="text"
                value={edit_pass}
                onChange={(val) => setedit_pass(val.target.value)}
              />
            </Form.Item>
            <Form.Item label="ຊື່ ແລະ ນາມສະກຸນ">
              <input
                className="form-control"
                type="text"
                value={edit_name}
                onChange={(val) => setedit_name(val.target.value)}
              />
            </Form.Item>

            <Form.Item label="ລະດັບເຂົ້າໃຊ້ງານ">
              <select
                value={edit_level}
                className="form-control"
                onChange={(val) => setedit_leve(val.target.value)}
              >
                <option value={"manager"}>manager</option>
                <option value={"sell"}>sell</option>
              </select>
            </Form.Item>
          </Form>
        </Modal>
      );
    }
    return (
      <>
        {loadingDelete && (
          <div
            style={{
              display: "block",
              position: "absolute",
              left: "49%",
            }}
          >
            <Spin />
          </div>
        )}
        <div className="container">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>ຊື່ເຂົ້າໃຊ້</th>
                <th>ຊື່</th>
                <th>ລະດັບຜູ້ໃຊ້ງານ</th>
                <th>ສະຖານະຜູ້ໃຊ້ງານ</th>
                <th>ການຈັດການ</th>
              </tr>
            </thead>
            <tbody>
              {data.map((values) => {
                return (
                  <tr key={values.id}>
                    <td>{values.id}</td>
                    <td>{values.user}</td>
                    <td>{values.name}</td>
                    <td>
                      <Tag color={values.level === "manager" ? "gold" : "blue"}>
                        {values.level === "manager" ? "ຜູ້ບໍລິຫານລະບົບ" : null}
                        {values.level === "sell" ? "ພະນັກງານຂາຍ" : null}
                        {values.level === "acc" ? "ພະນັກງານບັນຊີ" : null}
                      </Tag>
                    </td>
                    <td>
                      {values.status === 1 ? (
                        <Tag color="cyan"> ປົກກະຕິ</Tag>
                      ) : (
                        <Tag color="red"> ຖືກລະງັບ</Tag>
                      )}
                    </td>
                    <td>
                      <Button
                        onClick={() => {
                          setedit_id(values.id);
                          setedit_leve(values.level);
                          setedit_name(values.name);
                          showModal(values);
                        }}
                        className="mr-2"
                        type="dashed"
                        danger
                        ghost
                        disabled={values.status === 1 ? false : true}
                      >
                        ແກ້ໄຂ
                      </Button>
                      <Popconfirm
                        placement="topRight"
                        title={
                          values.status === 1
                            ? "ທ່ານຕ້ອງການຍົກເລີກຜູ້ໃຊ້ງານີ້ຫຼືບໍ່?"
                            : "ທ່ານຕ້ອງການອະນຸຍາດຜູ້ໃຊ້ງານີ້ຫຼືບໍ່?"
                        }
                        onConfirm={() => confirm(values)}
                        okText="ຕົກລົງ"
                        cancelText="ຍົກເລີກ"
                      >
                        <Button
                          type=" primary"
                          danger={values.status === 1 && true}
                          ghost={values.status === 1 && true}
                        >
                          {values.status === 1 ? "ຍົກເລີກໃຊ້ງານ" : "ເປີດໃຊ້ງານ"}
                        </Button>
                      </Popconfirm>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {modalEdit()}
        </div>
      </>
    );
  }

  function Adduser(props) {
    const { setdataShowUser } = props;
    const [loading, setloading] = useState(false);
    const onFinish = async (values) => {
      setloading(true);
      const { name, password, username } = values;
      let link = `${ip}users/register`;
      let dataSetForGet = {
        user: username,
        name: name,
        pass: password,
        level: "sell",
        fr: "sellonline",
        status: 1,
      };

      postData(
        message,
        link,
        dataSetForGet,
        token,
        retoken,
        user,
        dispatch,
        delUser,
        setUser,
        history,
        setWhenUpdate
      );

      function setWhenUpdate(result) {
        console.log(result);
        if (result.data.affectedRows === 1) {
          setloading(false);
          message.info("ບັນທືກຂໍ້ມູນສ້ຳເຫຼັ້ດ");
          setdataShowUser();
        } else {
          setloading(false);
          message.error("ບັນທືກຂໍ້ມູນບໍ່ສ້ຳເຫຼັ້ດ" + result.data.msg);
        }
      }
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 21 },
      },
    };
    return (
      <Form
        {...formItemLayout}
        name="addUser"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="ຊື່ເຂົ້າໃຊ້ງານ"
          name="username"
          rules={[
            {
              required: true,
              message: "ກະລຸນາເພີ່ມ ຜູ້ເຂົ້າໃຊ້ງານ!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="ລະຫັດຜ່ານ"
          name="password"
          rules={[
            {
              required: true,
              message: "ກະລຸນາເພີ່ມ ລະຫັດຜ່ານ!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="ຊື່ ແລະ ນາມສະກຸນ"
          name="name"
          rules={[
            {
              required: true,
              message: "ກະລຸນາເພີ່ມ ຊື່ ແລະ ນາມສະກຸນ!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button loading={loading} type="primary" htmlType="submit">
            ເພີ່ມຜູ້ໃຊ້ງານໃໝ່ເຂົ້າສູ່ລະບົບ
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default User;
